import { ReactNode } from "react";

import { Content } from "./content";

export const ExistingUser = (props: {
    EmailInput?: ReactNode;
    SiteNameInput?: ReactNode;
    NewSiteLink?: ReactNode;
    SitePicker?: ReactNode;
    SiteToggleButton?: ReactNode;
    PrivacyPolicy?: ReactNode;
    SubmitButton?: ReactNode;
}) => <Content {...props} />;
